import CardHeading from '@commons/headings/card'
import {
  StyleLeftBannerForm,
  StyleRightBannerForm,
  styleRowWrapper,
} from './style'
import Row from '@components/row'
import Button from '@components/button'
import Fields from '@components/fields'
import Column from '@components/column'
import { SettingSchema } from '@validations'
import { Formik, Form } from 'formik'
import { useState, useEffect } from 'react'
import { GeneralSetting } from '@apis'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
const initial = {
  value: {
    title: '',
    redirectLink: '',
  },
  file: '',
  key: '',
  group: 'banners',
}

const BannerForm = () => {
  const { state }: any = useLocation()
  const navigate = useNavigate()
  const { data: banners } = useSelector((state: any) => state.banners)
  const [initialValues, setInitialValues] = useState(initial)
  const [loading, setLoading] = useState<boolean>(false)
  const submitHandler = async (values: any, { resetForm }: any) => {
    setLoading(true)
    const payload: any = {
      group: values?.group,
      value: JSON.stringify(values?.value),
      key: !!values?.key ? values?.key : `banner-${banners?.length + 1}`,
    }
    if (values?.file?.base64) {
      payload.file = {
        base64: values?.file?.base64,
        extension: values?.file?.extension,
      }
    }
    if (state?.id) {
      await GeneralSetting.update({
        data: payload,
        id: state?.id,
        state: 'banners',
      })
        .then(() => {
          navigate('/admin/settings/marketing-settings')
        })
        .catch(() => {})
    } else {
      await GeneralSetting.create({
        data: payload,
        state: 'banners',
      })
        .then(() => {
          resetForm()
        })
        .catch(() => {})
    }

    setLoading(false)
  }
  useEffect(() => {
    if (state?.id) {
      setInitialValues({
        value: JSON.parse(state?.value),
        file: state?.file,
        key: state?.key,
        group: 'banners',
      })
    } else {
      setInitialValues(initial)
    }
  }, [state?.id])
  return (
    <Column bg="white" styleColumn="border-radius:12px;padding:15px;">
      <CardHeading title="Add New Banner" />
      <Formik
        initialValues={initialValues}
        onSubmit={submitHandler}
        enableReinitialize
        validationSchema={SettingSchema.bannerValidationSchema}
      >
        {({ handleSubmit }: any) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Column styleColumn="margin-top:20px" rowGap={15}>
                <Row
                  styleRow={styleRowWrapper}
                  justifyContent="space-between"
                  rowGap={15}
                >
                  <StyleLeftBannerForm>
                    <Fields.Input
                      label="Banner Title"
                      placeholder="Banner Title"
                      name="value[title]"
                    />
                    <Fields.Input
                      type="url"
                      label="Redirect Link"
                      placeholder="Redirect Link"
                      name="value[redirectLink]"
                    />
                  </StyleLeftBannerForm>
                  <StyleRightBannerForm>
                    <Fields.Upload
                      varient="drag"
                      name="file"
                      icon={'squareGallery'}
                      label="Banner Image"
                      size={120}
                      placeholder="Browse Image"
                    />
                  </StyleRightBannerForm>
                </Row>
                <Column alignItems="flex-end">
                  <Button
                    type="submit"
                    title="Save"
                    height={40}
                    loading={loading}
                  />
                </Column>
              </Column>
            </Form>
          )
        }}
      </Formik>
    </Column>
  )
}

export default BannerForm
